import React from 'react';

/** Public asset path for the Tauris wordmark (`frontend/public/logo.png`). */
export const TAURIS_LOGO_SRC = '/logo.png';

/**
 * Brand wordmark. Use on light surfaces by default.
 * On dark surfaces, wrap with a light chip or pass `onDark`.
 * Pass `responsive` + Tailwind `h-*` classes for fluid sizing.
 */
export default function BrandLogo({
    height = 48,
    className = '',
    style,
    onDark = false,
    compact = false,
    responsive = false,
    alt = 'Tauris',
    ...rest
}) {
    const padY = compact ? 4 : Math.max(8, Math.round(Number(height) * 0.12));
    const padX = compact ? 6 : Math.max(12, Math.round(Number(height) * 0.22));

    const img = (
        <img
            src={TAURIS_LOGO_SRC}
            alt={alt}
            height={responsive ? undefined : height}
            decoding="async"
            className={className}
            style={{
                height: responsive ? undefined : height,
                width: 'auto',
                maxWidth: '100%',
                maxHeight: responsive ? undefined : height,
                display: 'block',
                objectFit: 'contain',
                ...style,
            }}
            {...rest}
        />
    );

    if (!onDark) return img;

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#fff',
                borderRadius: compact ? 10 : 14,
                padding: `${padY}px ${padX}px`,
                lineHeight: 0,
                boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
            }}
        >
            {img}
        </span>
    );
}
